<template>
  <div class="serviceMain">
    <div class="searchBar">
      <div class="tittle"> 我的登记 </div>
      <div class="RegisterRedirect">
        <router-link v-if="userInfo.type == 'M'" :to="{path:'/Register?redirect=1'}"><el-button type="primary">登记</el-button></router-link> <!-- 渠道用户可以进行全流程登记 -->
        <el-button type="primary" @click="queryToday()" style="margin-left: 6px;">今日出证</el-button>
      </div>

      <div class="rightForm">
        <el-input
          v-model="form.subject"
          placeholder="请输入作品名称"
        ></el-input>
        <el-select v-model="selectedObligeeDisplay" filterable clearable placeholder="选择著作权人" @change="selectObligeesList" remote :remote-method="debouncedSearchObligee" @focus="handleFocus" @clear="handleClear">
            <!-- <el-option v-for="(item, index) in obligeesList" :key="index" :label="item.userName?item.userName:item.companyName" :value="item.obligeeCode"></el-option> -->
            <el-option v-for="(item, index) in obligeesList" :key="index" :label="getObligeeLabel(item)" :value="item.obligeeCode">
                <span v-if="item.userName">
                {{ item.userName }}
                <small v-if="item.uniqueCode" style="font-size: 12px; color: #999;">
                  ({{ item.uniqueCode.slice(-4) }})
                </small> 
              </span>
              <span v-else>
                {{ item.companyName }}
              </span>
            </el-option>
        </el-select>
        <el-date-picker
          type="date"
          v-model="startDateText"
          format="yyyy-MM-dd" 
          value-format="timestamp"
          placeholder="选择范围开始日期"
          @change="dateChange1"
          @paste.native="e => handlePaste(e, 'start')"
        >
        </el-date-picker>
        <el-date-picker
          v-model="endDateText"
          format="yyyy-MM-dd"
          value-format="timestamp"
          type="date"
          placeholder="选择范围结束日期"
          @change="dateChange2"
          @paste.native="e => handlePaste(e, 'end')"
        >
        </el-date-picker>
        <el-select v-model="form.processingTime" clearable placeholder="办理时限" @change="selectProcessingTime">
            <el-option label="1天" value="1"></el-option>
            <el-option label="3天" value="3"></el-option>
            <el-option label="5天" value="5"></el-option>
            <el-option label="15天" value="15"></el-option>
        </el-select>
        <el-select v-model="form.status" clearable placeholder="选择状态" @change="selectStatus">
            <el-option v-for="(item, index) in statusList" :key="index" :label="item.text" :value="item.code"></el-option>
        </el-select>
       <el-button @click="fetchData(2)">查询</el-button>
       <el-button @click="batchDownload" type="primary" :disabled="selectedRows.length>0?false:true">批量下载</el-button>
        <!-- <router-link :to="{path:'/Register'}">
            <el-button type="primary">新增登记</el-button>
        </router-link> -->
      </div>
    </div>

    <el-table
      ref="table"
      :data="tableData"
      :cell-class-name="tabelCellClass"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      v-loading="isLoading"
    >
      <el-table-column
        type="selection"
        width="30"
        :selectable="row => row.status == '21'"
        >
        <!-- 订单状态为21已完成的才可以选中下载的 -->
      </el-table-column>
      <el-table-column
        prop="subject"
        label="作品名称"
        show-overflow-tooltip
        width="160"
        fixed="left"
      >
      <template slot-scope="scope">
        <!-- 点击文件名也可以勾选 -->
        <span @click="toggleRowSelection(scope.row)">{{scope.row.subject}}</span>
      </template>
      </el-table-column>
      <el-table-column
        prop="right"
        label="著作权人"
        show-overflow-tooltip
        width="120"
      >
        <template slot-scope="scope">
          <!-- <span v-if="scope.row.obligeeInfo">{{scope.row.obligeeInfo.userName ? scope.row.obligeeInfo.userName : scope.row.obligeeInfo.companyName}}</span> -->
          <!-- <span v-if="scope.row.obligee.length>0">{{scope.row.obligee[0].obligeeName}}</span> -->
          <span v-for="(author, index) in scope.row.obligee" :key="index">
            {{author.obligeeType == "1" ? author.userName : author.companyName}}
            <template v-if="index < scope.row.obligee.length - 1">,</template>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="worksType"
        label="作品类型"
        show-overflow-tooltip
      >
      <template slot-scope="scope">
        <span>{{constants.worksType.find(item => item.value == scope.row.worksType).label}}</span>
      </template>
      </el-table-column>
      <el-table-column
        prop="processingTime"
        label="办理时限"
        sortable
        :sort-by="row => parseInt(row.processingTime)"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{scope.row.processingTime}}天</span>
          <!-- <span v-if="scope.row.processingTime">{{scope.row.processingTime}}天</span> -->
          <!-- <span v-else>-</span> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="issueDateText"
        label="出证时间"
        sortable
        :sort-by="row => parseInt(row.issueDate)"
        width="110"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.issueDate">{{scope.row.issueDateText}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
      <!-- <el-table-column
        prop="orderNo"
        label="订单号"
        width="180"
      >
      </el-table-column> -->
      <el-table-column
        prop="status"
        label="状态"
        width="90"
      >
        <template slot-scope="scope">
          <span
            class="stausCell"
            :class="{'stausCell1':scope.row.status=='31'|| scope.row.status=='32'|| scope.row.status=='33',
            'stausCell2':scope.row.status=='40',
            'stausCell3':scope.row.status=='11'|| scope.row.status=='12' || scope.row.status=='13' || scope.row.status=='20',
            'stausCell4':scope.row.status=='10',
            'stausCell5':scope.row.status=='21',}"
          >
            {{scope.row.statusText}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTimeText"
        label="创建时间"
        sortable
        width="120"
      >
        <!-- eslint-disable-next-line -->
        <template slot="header" slot-scope="scope">
          <div class="createTimeHeader">
            <span>创建时间</span>
            <a-tooltip>
              <template slot="title">
                <!-- prompt text -->
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="completeTimeText"
        label="创作完成日期"
        sortable
        :sort-by="row => parseInt(row.completeTime)"
        width="130"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.completeTime">{{scope.row.completeTimeText}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="publishTimeText"
        label="首次发表日期"
        sortable
        :sort-by="row => parseInt(row.publishTime)"
        width="130"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.publishTime">{{scope.row.publishTimeText}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="certificate"
        label="证书"
        width="90"
      >
        <template slot-scope="scope">
          <div class="signList">
            <span
              :class="{'graySpan':scope.row.status!='21','greenSpan':scope.row.status=='21'}" @click="getRegisterImg(scope.row.orderNo)"
            >
              登
              <!-- <i
                class="redBag"
                v-if="scope.row.status=='21'"
              > 1 </i> -->
            </span>
            <span
              :class="{'graySpan':scope.row.status!='21','greenSpan':scope.row.status=='21'}" @click="getExistImg(scope.row.extra.exist.orderNo)"
            >
              存
              <!-- <i
                class="redBag"
                v-if="scope.row.status=='21'"
              > 1 </i> -->
            </span>
               <!-- <span
              class="graySpan"
            >
              公
           
            </span> -->
          </div>

        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        fixed="right"
      >
        <!-- eslint-disable-next-line -->
        <template slot-scope="scope">
          <!-- {{scope.row.status}} -->
       
               <!-- <a-dropdown
            :trigger="['click']"
            placement="bottomLeft"
            overlayClassName="moveLeft"
          >
            <a @click.stop="e => e.preventDefault()">
              <a-icon type="more" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                 <router-link :to="{path:'/Register'}"> 重新登记 </router-link>  
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <a-icon type="right" class="ml12 gray" @click="onTabelRowClick(scope.row)" /> -->

          <router-link class="myDCIBtn" :to="{path:'/Register/Detail',query: {orderNo: scope.row.orderNo}}" target="_blank"> 详情 </router-link>
          <el-button class="myDCIBtn" @click="copyRegister(scope.row)" style="margin-right: 10px;"> 复制 </el-button> <!-- 只有个人作品和法人作品才能复制 -->
          <el-button class="myDCIBtn" @click="RepayAgain(scope.row)" v-if="scope.row.status=='10' && scope.row.issuingAuthority == 'HUBEI'" style="margin-right: 10px;"> 付款 </el-button>
          <el-button class="myDCIBtn" @click="RepayAgain2(scope.row)" v-if="scope.row.status=='10' && scope.row.issuingAuthority == 'NATIONAL' && scope.row.applyStatus == 'PAY'" style="margin-right: 10px;"> 付款 </el-button>
          <!-- <router-link class="myDCIBtn" :to="{path:'/Evaluate/EvaluateMain',query: {orderNo: scope.row.orderNo}}" v-if="scope.row.status=='21'"> 评价申请 </router-link> -->
          <el-button class="myDCIBtn" @click="downloadCertificateOne(scope.row.orderNo)" v-if="scope.row.status=='21'"> 证书下载 </el-button>
          <!-- 删除订单 -->
          <el-button class="myDCIBtn" @click="deleteRegister(scope.row.orderNo)" v-if="scope.row.status=='10' || scope.row.status=='32' ||scope.row.status=='33' ||scope.row.status=='40'"> 删除订单 </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
      :total="pagination.total"
      :current-page.sync="pagination.page"
      :page-size.sync="pagination.pageSize"
      :page-sizes="[10, 20, 30, 50]"
      @size-change="sizeChange"
      @current-change="currentChange"
      :pagerCount="5" 
    >
    </el-pagination>


      <!-- 图片预览 -->
      <el-image-viewer
        v-if="showImageViewer"
        :url-list="[showImageUrl]"
        hide-on-click-modal
        teleported
        :on-close="closePre"
      />
      <el-image-viewer
        v-if="showImageViewer2"
        :url-list="[showImageUrl2]"
        hide-on-click-modal
        teleported
        :on-close="closePre2"
      />

      <pay-dialog ref="payDialog" payForm="register" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { debounce } from 'lodash'
import {queryRegisterOrderList,queryRegisterOrder,queryExistOrder,paymentRegisterOrder,downloadEvidenceOne,downloadEvidence,deleteArchiveRegister} from '@/api/EvidenceService'
import { queryObligeeDetail,searchObligee } from "@/api/ObligeeService";
import PayDialog from "../../../components/PayDialog";
import { saveAs } from 'file-saver'; //使用 FileSaver.js 下载文件..FileSaver.js是一个流行的库，可以简化文件下载操作
import constants from "@/utils/constants";

export default {
  name: 'MyRegister',
  components: {
      'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
      PayDialog
  },
  data () {
    return {
      constants,

      startDateText: null,
      endDateText: null,
      form: {
        subject: null,
        startDate: null,
        endDate: null,
        obligeeCode: null,
        status: null,
        processingTime: null,
        issueDate: null, //// 添加 issueDate 字段,：今日出证
      },
      selectedObligeeDisplay: null, // 选择的著作权人显示文字（包含个人里面后四位身份证尾号）
      isLoading: false,
      pagination: {
        total:0,
        page: 1,
        pageSize: 10
      },
      tableData:[],
      obligeesList: [],
      statusList: [
        {code: '10',text:'待付款'},
        {code: '11',text:'待审核'},
        {code: '20',text:'已审核'},
        {code: '21',text:'已完成'},
        {code: '31',text:'申领失败'},
        {code: '32',text:'初审驳回'},
        {code: '33',text:'终审驳回'},
        {code: '40',text:'已取消'},
      ],
      
      showImageViewer: false,
      showImageUrl: '',
      showImageViewer2: false,
      showImageUrl2: '',

      selectedRows: [], // 批量下载选中

      // 创建防抖函数，500ms内只执行一次
      debouncedSearchObligee: debounce(this.searchObligee, 500),
    }
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo","obligeeList"]),

    // 匹配列表里面的著作权人
    // tableDataNew(){
    //   // 创建用户ID到姓名的映射表
    //   const userMap = new Map(this.obligeeList.map(item => [item.obligeeCode,item]))
    //   return this.tableData.map(order => ({
    //     ...order,
    //     obligeeInfo: userMap.get(order.obligee[0]) || '未知' // 添加默认值
    //   }))
    // }
  },
  watch: {
    // 监听vuex里面mapGetters的obligeeList的改变
    obligeeList: {
      handler(newVal, oldVal) {
        // 当 obligeeList 或其内部发生变化时执行
        // console.log('obligeeList 发生变化newVal:', newVal);
        // console.log('obligeeList 发生变化oldVal:', oldVal);
        // 在这里添加你的逻辑
        if(oldVal == null){ // 页面加载完，著作权人还没有加载到，后面才加载到的情况，再改倒序
          this.obligeesList = [...newVal];
        }else{
          this.obligeesList = newVal;
        }
      },
      deep: true // 深度监听
    }
  },
  // created() {
  //   this.loadData();
  // },
  activated() { // 每次进入页面时调用数据获取方法，避免多次请求，注释created
      this.fetchData();
  },
  methods: {
    onTabelRowClick(row){
      this.$router.push({
        path: "/Register/Detail",
            query: {orderNo:row.orderNo}
      });
    },
    tabelCellClass ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'certificate') {
        return 'certificateCell'
      }
    },
    getStatus(code){
        switch(code){
          case '10':return '待付款';
          case '11':return '待审核';
          case '20':return '已审核';
          case '21':return '已完成';
          case '31':return '申领失败';
          case '32':return '初审驳回';
          case '33':return '终审驳回';
          case '40':return '已取消';
        }
    },
    async loadData (param) {
      try {
        if(this.obligeeList){
          this.obligeesList = this.obligeeList;
        }else{
          this.bus.$emit("refreshObligee");  // 更新请求事件总线中vuex的著作权人列表
          this.$message.warning("正在获取著作权人列表")
          // 如果数据还未加载完成，可以设置监听或延迟检查
          const timer = setInterval(() => {
              if (this.obligeeList) {
                  this.obligeesList = this.obligeeList;
                  clearInterval(timer);
              }
          }, 100);
        }
        await this.fetchData();
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    fetchData(type){ // 查询列表函数
      this.isLoading = true
      // 逻辑调整：
      // 1. type === 2：普通查询，重置 issueDate
      // 2. type === 'today'：今日查询，不重置 issueDate（已经在 queryToday 中设置）
      // 3. 无参数或 type === 'page'：翻页操作，保持所有条件不变
      if (type === 2) {
        // 普通查询按钮，重置 issueDate 并重置页码
        this.form.issueDate = null;
        this.pagination.page = 1;
      } else if (type === 'today') {
        // 今日查询，只重置页码，不重置 issueDate
        this.pagination.page = 1;
      }
      queryRegisterOrderList(this.pagination.page,this.pagination.pageSize,this.form).then(({data})=>{
          for (let i = 0; i < data.list.length; i++) {
            const element = data.list[i];
            element.num=element.items.length;
            element.statusText=this.getStatus(element.status);
            element.createTimeText= this.dayjs(element.createTime*1000).format('YYYY-MM-DD\nHH:mm:ss');
            element.issueDateText= this.dayjs(element.issueDate*1000).format('YYYY-MM-DD');
            element.completeTimeText= this.dayjs(element.completeTime*1000).format('YYYY-MM-DD');
            element.publishTimeText= this.dayjs(element.publishTime*1000).format('YYYY-MM-DD');
      // this.orderInfo.updateTimeText= this.dayjs(this.orderInfo.updateTime*1000).format('YYYY-MM-DD HH:mm:ss ');
          }
        this.tableData=data.list;
        this.pagination.total=data.total*1;
        this.isLoading = false
      });
    },
    // 在按钮点击事件中
    queryToday() {
        this.form = {
          subject: null,
          startDate: null,
          endDate: null,
          obligeeCode: null,
          status: null,
          processingTime: null,
          issueDate: null,  // 重置时也清空
        };
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.form.issueDate = Math.floor(today.getTime() / 1000);
        this.fetchData('today');  // 传递特殊类型
    },

    sizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.fetchData()
    },
    currentChange (pageNum) {
      // 更新表格数据
      this.fetchData()
    },

    // 著作权人-查询列表
    selectObligeesList(obligeeCode){
      if (!obligeeCode) {
        this.form.obligeeCode = null;
        this.selectedObligeeDisplay = null;
      } else {
        this.form.obligeeCode = obligeeCode;
        const selected = this.obligeeList.find(item => item.obligeeCode === obligeeCode);
        this.selectedObligeeDisplay = selected ? this.getObligeeLabel(selected) : null;
      }
    },
    getObligeeLabel(item) {
      if (!item) return '';
      if (item.userName) {
        return item.uniqueCode ? `${item.userName} (${item.uniqueCode.slice(-4)})` : item.userName;
      }
      return item.companyName || '';
    },
    // 输入搜索著作权人
    async searchObligee(query){
      // console.log(query);
      if (query !== '') {
        try {
          // 调用API接口，query是用户输入的搜索词
          let params = {
            obligeeName: query
          }
          searchObligee(params).then(({data})=>{
            // 将搜索的结果，与this.obligeeList对比，如果不存在，则添加进本地obligeeList缓存
            // console.log(this.obligeeList);
            // console.log(this.obligeesList);
            // 1. 获取array1中所有的obligeeCode值
            const existingCodes = this.obligeeList.map(item => item.obligeeCode);
            // 2. 筛选出 obligeesList 中不存在于 obligeeList 的项
            const itemsToAdd = [];
            for (const item of data.list) {
              if (!existingCodes.includes(item.obligeeCode)) {
                itemsToAdd.push(item);
              }
            }
            // 3. 将这些对象添加到obligeeList中，合并数组并更新 store
            const mergedArray = [...itemsToAdd, ...this.obligeeList];
            // 更新本地缓存
            this.$store.commit("setObligeeList", mergedArray);

            // 4. 确保 Vuex 更新完成后，并且本地监听obligeeList改变obligeesList之后，再手动更新 obligeesList
            this.$nextTick(() => {
              this.obligeesList = data.list || [];
            });
          })
        } catch (error) {
          console.error('搜索权利人失败:', error)
          this.obligeesList = []
        }
      } else {
        this.obligeesList = this.obligeeList; // 继续调用缓存的obligeeList
      }
    },
    handleFocus(){ // 获取焦点之后
      this.obligeesList = this.obligeeList; // 继续调用缓存的obligeeList
    },
    handleClear(){ // 清除内容之后
      this.obligeesList = this.obligeeList; // 继续调用缓存的obligeeList
      this.selectedObligeeDisplay = null;
      this.form.obligeeCode = null;
    },

    // 时间范围-查询列表
    dateChange1(val){
      if(val === '' || val === null || val.length === 0){
        // console.log('选择已被清空'); // 执行其他逻辑...
        this.form.startDate = null;
      }else{
        this.form.startDate = Math.floor(val / 1000);
      }
    },
    dateChange2(val){
      if(val === '' || val === null || val.length === 0){
        // console.log('选择已被清空'); // 执行其他逻辑...
        this.form.endDate = null;
      }else{
        this.form.endDate = Math.floor(val / 1000);
      }
    },
    handlePaste(e, type) {
      const s = ((e.clipboardData || window.clipboardData).getData('text') || '')
        .replace(/[－—–]/g, '-')
        .replace(/[．。]/g, '.')
        .replace(/[／]/g, '/')
        .replace(/[年月]/g, '-')
        .replace(/日/g, '')
        .replace(/\s/g, '');
      const m = s.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/);
      if (!m) return;
      const d = new Date(+m[1], +m[2] - 1, +m[3]);
      if (d.getFullYear() != m[1] || d.getMonth() != m[2] - 1 || d.getDate() != m[3]) return;
      e.preventDefault();
      const ts = d.getTime();
      if (type === 'start') {
        this.startDateText = ts;
        this.dateChange1(ts);
      } else {
        this.endDateText = ts;
        this.dateChange2(ts);
      }
    },

    // 状态-查询列表
    selectStatus(index){
      // console.log(index);
      if(index === '' || index === null || index.length === 0){
        // console.log('选择已被清空'); // 执行其他逻辑...
        this.form.status = null;
      }else{
        this.form.status = index;
      }
    },
    //  是否加急-查询列表
    selectProcessingTime(val){
      if(val === '' || val === null || val.length === 0){
        // console.log('选择已被清空'); // 执行其他逻辑...
        this.form.processingTime = null;
      }else{
        this.form.processingTime = val;
      }
    },

    // 放大证书
    getRegisterImg(orderNo){
      queryRegisterOrder(orderNo).then(({ data }) => {
        // console.log("登记详情：",data);
        document.body.style.overflow = 'hidden';
        this.showImageUrl = data.certificateInfo.jpgUrl;
        this.showImageViewer = true;
      })
    },
    closePre(){
      document.body.style.overflow = 'auto';
      this.showImageUrl = '';
      this.showImageViewer = false;
    },


    // 获取存证图片
    getExistImg(orderNo){
      // console.log(orderNo);
      queryExistOrder(orderNo).then(({ data }) => {
        // console.log("存证详情：",data);
        document.body.style.overflow = 'hidden';
        this.showImageUrl2 = data.certificateInfo.jpgUrl;
        this.showImageViewer2 = true;
      })
    },
    closePre2(){
      document.body.style.overflow = 'auto';
      this.showImageUrl2 = '';
      this.showImageViewer2 = false;
    },

    // 重新付款（登记）
    RepayAgain(row) {
      let that = this;
      paymentRegisterOrder(row.orderNo).then(({data})=>{
            that.$refs.payDialog.showDialog(data);
            that.isPayDialogVisible = true;
      })
    
    },
    // 重新付款(数登)
    RepayAgain2(row){
      // 重新付款接口（不同于支付接口）
      paymentRegisterOrder(row.orderNo).then(({ data }) => {
        this.order = data;
        console.log("order::::::::::::",this.order);
        if (data.paymentStatus == "21") {
          // this.bus.$emit("refreshVip");
          // this.onSetPayDialogClose(true);
        } else {
          // this.$refs.payDialog.showDialog(data);
          this.isPayDialogVisible = true;
          // console.log(data.paymentRequest.payUrl);
          // 打开第三方支付宝支付接口页面
          window.open(data.paymentRequest.payUrl);
        }
      });
    },

    // 批量下载选中
    handleSelectionChange (val) {
      this.selectedRows = val;
      // console.log(this.selectedRows);
    },
    // 点击作品名称也可以勾选
    toggleRowSelection(row) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 单个证书下载
    async downloadCertificateOne(orderNo) {
      // 创建Loading实例
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在下载文件...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      try {
        // const response = await downloadEvidenceOne(orderNo, { responseType: 'blob' });
        const response = await downloadEvidence(orderNo, { responseType: 'blob' });   // 暂时不使用单个下载接口，统一使用批量下载接口。
        
        // 获取文件名
        let fileName = 'download.zip';
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/i);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = decodeURIComponent(fileNameMatch[1]);
          }
        }
        
        const blob = new Blob([response.blob], { type: 'application/zip' });
        saveAs(blob, fileName || 'download.zip');
        loadingInstance.close();
        this.$message.success('文件下载成功');
      } catch (error) {
        loadingInstance.close();
        console.error('文件下载失败:', error.message);
        this.$message.error('文件下载失败');
      }
    },
    // 批量下载（当只勾选一个时使用单个接口，勾选多个时使用批量接口）
    batchDownload() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先勾选需要下载的登记作品');
        return;
      }
      if (this.selectedRows.length > 10) {
        this.$message.warning('一次批量下载数量不能超过10条');
        return;
      }
      // 只勾选一个时，使用单个下载接口
      if (this.selectedRows.length === 1) {
        const orderNo = this.selectedRows[0].orderNo;
        this.downloadCertificateOne(orderNo);
      } else {
        // 勾选多个时，使用批量下载接口
        let orderNoStr = this.selectedRows.map(item => item.orderNo).join(',');
        this.downloadCertificateBatch(orderNoStr);
      }
    },
    // 批量下载执行（使用原downloadEvidence接口）
    async downloadCertificateBatch(orderNoStr) {
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在下载文件...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      try {
        const response = await downloadEvidence(orderNoStr, { responseType: 'blob' });
        
        let fileName = 'download.zip';
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/i);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = decodeURIComponent(fileNameMatch[1]);
          }
        }
        
        const blob = new Blob([response.blob], { type: 'application/zip' });
        saveAs(blob, fileName || 'download.zip');
        loadingInstance.close();
        this.$message.success('文件下载成功');
      } catch (error) {
        loadingInstance.close();
        console.error('文件下载失败:', error.message);
        this.$message.error('文件下载失败');
      }
    },

    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        this.loadData();
      }
    },

    // 点击“复制”，跳转到登记step页面，覆盖缓存
    async copyRegister(row){
      try {
        // 第一步： 先判断该订单的著作权人，是否在该平台的著作权人列表里面
        // let obligee = '';
        // for(let i in this.obligeeList){
        //   if(this.obligeeList[i].obligeeCode == row.obligee[0].obligeeCode){
        //     obligee = this.obligeeList[i].obligeeCode
        //   }
        // }
        // let obligee = row.obligee[0].obligeeCode;
        // console.log('obligee===',obligee);
        // 第二步：如果存在该著作权人，就请求详细信息
        let right = [];
        if(row.obligee.length > 0){
          // this.isLoading = true;
          // await queryObligeeDetail(obligee).then(({ data }) => {
          //   // console.log('著作权人详情：',data);
          //   right = [data];
          //   this.isLoading = false;
          // }).catch(error => {
          //   this.isLoading = false;
          //   return Promise.reject(error);
          // });
          right = row.obligee;
        }
        // console.log(right);

        // 如果是 8 和 10 美术和摄影，不需要复制内容简介和创作过程
        let creationProcess = row.creationProcess;
        let creationIntention = row.creationIntention;
        if(row.worksType == 8 || row.worksType == 10){
          creationProcess = {text: ""}
          creationIntention = {text: ""}
        }
        
        // 第三部：本地存储之后，跳转到登记页面
        // console.log('row',row);
          let form= {
            // paymode: row.paymode,
            paymode: 'vip',
            right: right,
            creationNature: row.creationProperty,
            creationPropertyDesc: row.creationPropertyDesc,
            finishTime: row.completeTime?row.completeTime*1000:'',
            creationIntention: creationIntention,
            creationProcess: creationProcess,
            province: row.completeLocation.province,
            city: row.completeLocation.city,
            publishStatus: row.publishStatus, 
            province2: row.publishLocation?row.publishLocation.province:'',
            city2: row.publishLocation?row.publishLocation.city:'',
            publishTime: row.publishTime?row.publishTime*1000:'',
            subject: row.subject,
            worksType: row.worksType,
            files: [],//row.items,//复制登记，不用带文件，以及图片
            ownership: row.belong,
            obtainType: row.obtainType,
            authors: row.authors,
            obtainTypeDesc: row.obtainTypeDesc,
            // ownershipPicture: {
            //   "additionalProp1": "",
            //   "additionalProp2": "",
            //   "additionalProp3": "",
            //   "additionalProp4": "",
            //   "additionalProp5": "",
            //   "additionalProp6": "",
            // },//row.ownershipPicture,
            ownershipPicture: {
              "additionalProp1": "",
              "additionalProp2": row.ownershipPicture.additionalProp2,
              "additionalProp3": "",
              "additionalProp4": "",
              "additionalProp5": "",
              "additionalProp6": "",
            },
            rightHave: row.copyrights,
            extra: row.extra?row.extra : { processingTime: '15',},
            orderType: row.orderType,
          }
          // 覆盖/添加缓存
          if(row.orderType == '02' || (row.orderType == '03' && (row.belong == '1' || row.belong == '3'))){ // 渠道本地登记缓存
            localStorage.setItem(`form02_${this.mid}`, JSON.stringify(form));
          }else{  // 全流程本地登记缓存
            localStorage.setItem(`form01_${this.mid}`, JSON.stringify(form));
          }
          // 再进行页面跳转
          let type = 'register';
          // this.$router.push('/Register');
          if(row.orderType == '02' || (row.orderType == '03' && (row.belong == '1' || row.belong == '3'))){   //个人作品和法人作品,跳转到渠道登记 //03是api渠道过来的，有全流程和渠道两种，再进行细分（根据权属）1个人作品/3法人作品
            this.$router.push({path: '/Register',query: {type: type,orderNo: row.orderNo}});
          }else{   //其他作品,跳转到全流程登记
            this.$router.push({path: '/Register?redirect=1',query: {type: type,orderNo: row.orderNo}});
          }

      } catch (error) {
        console.error("处理过程中出错:", error);
      }

    },

    // 点击删除订单
    deleteRegister(orderNo){
      console.log(orderNo);
      this.$confirm('是否确认删除该登记订单?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 确认操作
        this.isLoading = true;
        try {
          //生成登记证书
          deleteArchiveRegister(orderNo).then(data => {
            this.isLoading = false;
            this.$message({
              message: "删除登记订单成功",
              type: "success"
            });
            this.fetchData();
          });
        } catch (error) {
          this.isLoading = false;
          this.$message({
              message: error.msg,
              type: "error"
            });
        }
      }).catch(() => {
        // 取消操作
      })
    },

  }
}
</script>

<style lang='scss' scoped>
@import '../../../assets/css/mine.scss';
.myDCIBtn{color: #1884FF;background: transparent;padding: 0;border: none;margin: 0;display: inline-block;}
.myDCIBtn:nth-child(1){margin-right: 10px;}
.myDCIBtn:hover,.myDCIBtn:focus{background: transparent;}
.myDCIBtn2{background: transparent;padding: 0;border: none;margin: 0;display: inline-block;}
.myDCIBtn2:hover{background: transparent;color: #C0C4CC;}
.myDCIBtn:disabled{color: #C0C4CC;}
.el-select{margin-left: 16px;}
/deep/.searchBar{align-items: flex-start;}
/deep/.searchBar .tittle{min-width: 80px;}
/deep/.el-date-editor{width: 180px!important;}
/deep/.searchBar .el-button{margin-top: 16px;}
/deep/.searchBar .rightForm{flex-wrap: wrap;justify-content: flex-end;align-items: baseline;}
/deep/.searchBar .rightForm .el-button{margin-left: 16px;}
/deep/.searchBar .rightForm .el-button:last-child{margin-left: 12px;}
/deep/.searchBar .rightForm .el-input{width: 180px;}
/deep/.searchBar .el-select:nth-child(5) .el-input,/deep/.searchBar .el-select:nth-child(6) .el-input{width: 180px;}
/deep/.el-table td.el-table__cell div{white-space: pre-line;}

.searchBar{position: relative;}
.RegisterRedirect{position: absolute;left: 0;bottom: 0;}
.RegisterRedirect button{border-radius: 4px;}

@media screen and (max-width: 991px){
    .serviceMain{padding: 20px;}
    .searchBar{display: block;}
    .searchBar .tittle{margin-bottom: 10px;}
  }
</style>
